import React, { memo } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Stack from "@mui/material/Stack";
import { SxProps } from "@mui/system";

interface LoaderProps {
  position?: "fixed" | "absolute" | "relative" | "static" | "sticky";
  loading?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
  _sx?: SxProps;
}

const Loader: React.FC<LoaderProps> = ({ 
  position = "fixed", 
  loading = false, 
  size = "xs", 
  _sx 
}) => {
  const sizes: Record<string, number> = {
    xs: 32,
    sm: 56,
    md: 72,
    lg: 94
  };

  return (
    <Stack
      sx={{
        background: "#d3d3d396",
        justifyContent: "center",
        alignItems: "center",
        position: position,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: loading ? 100000 : -1,
        visibility: loading ? "visible" : "hidden",
        ..._sx
      }}
    >
      {/* Optional loader image */}
      {/* <img
        src="/loader.gif"
        alt="loader"
        style={{ width: sizes[size], borderRadius: 3 }}
      /> */}
      <CircularProgress size={sizes[size] || sizes.md} sx={{color:"#FFCB08"}}/>
    </Stack>
  );
};

export default memo(Loader);
